import _ from 'lodash';
const round = function (val, precision = 2) {
  return _.round(val, precision);
};

export {
  round,
};
